export default "__VITE_ASSET__DVITQ0Np__"